module.exports = __webpack_public_path__ + "img/bag2.b30bd707.png";